import React from "react";
import { Link, NavLink } from "react-router-dom";
import { Icon } from "zina-dogi-react";
import "./item_table.scss";

const titles = [
    "S.No",
    "Customer Material Number",
    "Description",
    "QTY",
    "UOM",
    "Unit Price",
    "Line Total",
    "Marks",
    "Work by",
    "CP code",
    "Spent",
    "          "
];

const ItemTable = ({ items, cpo_number, className, cpo }) => {
    const rows =
        items &&
        Object.values(items).map((item, index) => {
            return (
                <tr key={`item_value_${index}`}>
                    <td>
                        <Link
                            to={{
                                pathname: `/detail/${cpo.id}/item/${item.item}`,
                                state: { cpoNumber: cpo_number }
                            }}
                        >
                            #{item.item}
                        </Link>
                    </td>
                    <td>{item.code}</td>
                    <td>{item.description}</td>
                    <td>{item.quantity}</td>
                    <td>{item.extra_fields && item.extra_fields.uom}</td>
                    <td>{item.value_on_cpo}</td>
                    <td>{item.gross_value}</td>
                    <td>{item.extra_fields && item.extra_fields.marks}</td>
                    <td>{item.extra_fields && item.extra_fields.work_by}</td>
                    <td>{item.extra_fields && item.extra_fields.cp_code}</td>
                    <td>{item.extra_fields && item.extra_fields.quantity_spent_external}</td>
                    <td>
                        {item.cancelled ? (
                            <div>
                                <Icon icon="times-circle" /> Cancelled
                            </div>
                        ) : (
                            ""
                        )}
                    </td>
                </tr>
            );
        });
    return (
        <div {...{ className }}>
            <div className="content">
                <table className="table table-bordered table-striped">
                    <thead className="thead-dark">
                        <tr>
                            {titles &&
                                titles.map((title, index) => (
                                    <th key={`item_title_${index}`} scope="col">
                                        {title}
                                    </th>
                                ))}
                        </tr>
                    </thead>
                    <tbody>{rows}</tbody>
                </table>
            </div>
            {/* <Pagination {...pagination} /> */}
        </div>
    );
};

ItemTable.header = (fns, props) => {
    const { cpo } = props;
    const disabled = !(cpo && cpo.cpo_register && cpo.cpo_register.circle);
    const cancelled = !(cpo && cpo.cpo_register && cpo.cpo_register.status !== "cancelled");
    const hasOet = cpo && cpo.oet && !Array.isArray(cpo.oet);
    const isVodafone = cpo && cpo.customer && cpo.customer.toLowerCase().includes("vodafone");
    // console.log(props);
    const to = {
        pathname: `/detail/${cpo.id}/add_item`,
        state: { cpoNumber: cpo.number }
    };
    return (
        <nav className="navbar">
            <span className="navbar-brand h4 ">CPO Items Level.</span>
            <div>
                {!cancelled && !hasOet && isVodafone && (
                    <NavLink
                        className={["btn", "btn-success", "ml-1", ...(disabled ? ["disabled"] : [])].join(" ")}
                        to={`/cpoitemimporter/${props.cpo_id}/`}
                        aria-disabled={disabled}
                    >
                        CPO Items Importer
                    </NavLink>
                )}
                {cpo && (
                    <NavLink
                        className={["btn", "btn-primary", "ml-1", ...(cancelled ? ["disabled"] : [])].join(" ")}
                        to={to}
                        aria-disabled={cancelled}
                    >
                        Add new Item
                    </NavLink>
                )}
            </div>
        </nav>
    );
};

export default ItemTable;
